import { useUpdateEffect } from 'react-use';

import { GuardianPesel } from '@dreryk/personal-external-identifier-common-api';

import { FormContextValues, useBoolean } from '@dreryk/react-common';
import { FormController, GuardianPeselInput } from '@dreryk/react-components';

import { patientTranslationKeys } from '../../../../translations';
import { GuardianModalFormBean } from '../../../GuardianModal/GuardianModal.types';
import { PersonFormGuardianModal } from '../../PersonFormGuardianModal';

import { StyledGuardianPeselField } from './GuardianPeselField.styled';

type GuardianPeselFormBeanPart = {
   guardianPesel?: GuardianPesel | null;
   identifyingGuardian?: GuardianModalFormBean;
};
type GuardianPeselFieldProps = Pick<FormContextValues<GuardianPeselFormBeanPart>, 'register' | 'watch' | 'setValue'> & {
   patientId?: number;
};

export const GuardianPeselField = (props: GuardianPeselFieldProps): JSX.Element => {
   const { guardianPesel } = props.watch(['guardianPesel']);
   const [{ setFalse: closeModal, setTrue: openModal }, modalVisible] = useBoolean(!guardianPesel);

   useUpdateEffect(() => {
      if (!guardianPesel) {
         openModal();
      }
   }, [guardianPesel]);

   return (
      <>
         <StyledGuardianPeselField>
            <GuardianPeselInput
               controller={props.register('guardianPesel', { required: true })}
               label={patientTranslationKeys.personalIdentifier}
               testId={'guardianPesel'}
               disabled
            />

            <FormController controller={props.register('identifyingGuardian')} defaultValue={null} />
         </StyledGuardianPeselField>

         {modalVisible ? (
            <PersonFormGuardianModal patientId={props.patientId} setValue={props.setValue} onClose={closeModal} />
         ) : null}
      </>
   );
};
